import React from 'react';

export default function Certificate(){
  return (
    <main style={{padding:24}}>
      <h1>Certificates</h1>
      <p>ISO and industry compliance certificates are available upon request.</p>
    </main>
  );
}
